import { getConfigApi, setConfigApi } from '@/apis/user'
// line 1-superCustomerId 2-mainCustomerId 3-customerId
export interface CONFIG_TYPE {
  configCode:string
  configName:string
  level: number
}
export enum ENUM_CONFIG_CODE {
  /** 首页line弹窗 */
  LINE_MODAL = 'LINE_MODAL',
  /** 关联商品提示 */
  API_ASSOCIATED = 'API_ASSOCIATED',
  /** 关联商品流程提示 */
  API_ASSOCIATED_FLOW = 'API_ASSOCIATED_FLOW',
  /** 商品管理弹窗 */
  ASSOCIATED_PRODUCTLIB_TIP = 'ASSOCIATED_PRODUCTLIB_TIP',
  /** 首页设置号码弹窗 */
  SIGNUP_MODAL = 'SIGNUP_MODAL',
  /** 工作台菜单 */
  WORKBENCH_MENU = 'WORKBENCH_MENU',
  /** 零售书下载 */
  RETAIL_BOOK = 'RETAIL_BOOK',
  /** 2B2C模式介绍 */
  NOT_FIRST_USE_B2B = 'NOT_FIRST_USE_B2B',
  /** 购物车2B2C模式介绍 */
  NOT_FIRST_USE_CART = 'NOT_FIRST_USE_CART',
}
export enum ENUM_LEVEL {
    /** 超级id */
    SUPER_CUSTOMER_ID = 1,
    /** 主账号 */
    MAIN_CUSTOMER_ID,
    /** 子账号 */
    CUSTOMER_ID
}
const config:Map<string, CONFIG_TYPE> = new Map([
  [
    'LINE_MODAL',
    {
      configCode: 'LINE_MODAL',
      configName: 'line弹窗',
      level: 1
    }
  ],
  [
    'API_ASSOCIATED',
    {
      configCode: 'API_ASSOCIATED',
      configName: '关联商品提示',
      level: 1
    }
  ],
  [
    'API_ASSOCIATED_FLOW',
    {
      configCode: 'API_ASSOCIATED_FLOW',
      configName: '关联商品流程提示',
      level: 1
    }
  ],
  [
    'ASSOCIATED_PRODUCTLIB_TIP',
    {
      configCode: 'ASSOCIATED_PRODUCTLIB_TIP',
      configName: '商品管理弹窗',
      level: 1
    }
  ],
  [
    'SIGNUP_MODAL',
    {
      configCode: 'SIGNUP_MODAL',
      configName: '设置号码弹窗',
      level: 1
    }
  ],
  [
    'RETAIL_BOOK',
    {
      configCode: 'RETAIL_BOOK',
      configName: '零售书下载',
      level: 3
    }
  ],
  [
    'Guide_Plat',
    {
      configCode: 'Guide_Plat',
      configName: '2B2C模式介绍',
      level: 3
    }
  ],
  [
    'NOT_FIRST_USE_B2B',
    {
      configCode: 'NOT_FIRST_USE_B2B',
      configName: '非第一次进入代采或b2b',
      level: 1
    }
  ],
  [
    'NOT_FIRST_USE_CART',
    {
      configCode: 'NOT_FIRST_USE_CART',
      configName: '非第一次进入购物车',
      level: 1
    }
  ]
])
export const useUserConfig = (key:ENUM_CONFIG_CODE):[() => Promise<any>, (v:any) => Promise<any>] => {
  const { configCode, level, configName } = config.get(key) as CONFIG_TYPE
  const getUserConfig = async () => {
    const res = await getConfigApi({
      configCode,
      level
    })
    return res.data.configValue
  }
  const setUserConfig = async (val:any) => {
    await setConfigApi({
      configCode,
      configName,
      configValue: val
    })
  }
  return [getUserConfig, setUserConfig]
}

export default useUserConfig
